import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdTestingProgramsSuspense } from "api/generated/users/users";

export function useTestingProgramsForUserQuery(userId: number) {
    return useGetUsersUserIdTestingProgramsSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
